import { render, staticRenderFns } from "./GUserInfoForm.vue?vue&type=template&id=c9426420&scoped=true&"
import script from "./GUserInfoForm.vue?vue&type=script&lang=ts&"
export * from "./GUserInfoForm.vue?vue&type=script&lang=ts&"
import style0 from "./GUserInfoForm.vue?vue&type=style&index=0&id=c9426420&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9426420",
  null
  
)

export default component.exports